export const MAX_BANNER_SIZE = 1024 * 1024 * 5 // 5mb

export const ALLOWED_IMAGE_MIME_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']

// Aspect ratio ~ 1.72
export const BANNER_WIDTH = 1572
export const BANNER_HEIGHT = 912
